let parent = document.querySelector('head')
// 移除promotion页面
const removePromotionMeta = () => {
  if (document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]'))
  }
}

// 移除function页面
const removeFunctionMeta = () => {
  if (document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]'))
  }
}

// 移除列表页(也是搜索页)
const removeListMeta = () => {
  if (document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]'))
  }
}

// 移除详情页(PDP)
const removeDetailMeta = () => {
  if (document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.CATALOGTYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGETYPE"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTGROUP"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PAGENAME"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTCATEGORY"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTID"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTID"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTSUBCATEGORY"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTSUBCATEGORY"]'))
  }
  if (document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTSUBCATEGORY2"]')) {
    parent.removeChild(document.querySelector('meta[name="PHILIPS.METRICS.PRODUCTSUBCATEGORY2"]'))
  }
}

export default {
  removePromotionMeta,
  removeFunctionMeta,
  removeListMeta,
  removeDetailMeta
}



// WEBPACK FOOTER //
// ./src/assets/js/removeMeta.js